export default {
  sponsorName : {
      //width : "300px",
      //marginLeft : "15px",
  },
  enrollerName : {
    color : "#153862",
    position: "absolute",
    left: "120px",
    fontSize : "12px",
    height: "32px",
    padding: "7px",
    borderLeftStyle: "solid",
    borderLeftWidth: "1px",
  },
  enrollerNameDis : {
    color : "#9d9e9f",
    position: "absolute",
    left: "120px",
    fontSize : "12px",
    height: "32px",
    padding: "7px",
    borderLeftStyle: "solid",
    borderLeftWidth: "1px",
  },
  loading: {
    marginLeft : "5px",
    position: "absolute",
    marginTop : "-7px",
  }
}



// WEBPACK FOOTER //
// ./src/components/StartContainer/Sponsor/SponsorName/sponsorName.style.js